'use client';

import * as Sentry from '@sentry/react';
import React from 'react';
import { ClientProviders as CommonClientProviders } from '@order-up/client/vite';
import { AppShellError } from './AppShellError';
import { OnboardingLoadingShell } from './OnboardingLoadingShell';

export function ClientProviders({ children }: { children: React.ReactNode }) {
    return (
        <CommonClientProviders
            defaultTheme="dark"
            themeStorageKey="orderup-onboarding-theme"
            // Boot (Firebase-init) skeleton — same shell the auth handoff
            // renders, so the user sees one continuous loading frame.
            loadingComponent={<OnboardingLoadingShell />}
            // Previously errorFallback={null} + a no-op onError, so any error
            // caught inside the provider tree blanked the screen AND reported
            // nothing. Now: show a real error card and forward the error to
            // Sentry (captured by the global hub init'd in main.tsx).
            errorFallback={
                <AppShellError
                    title="Something went wrong"
                    description={
                        <p>
                            We hit an unexpected error. Please refresh and try
                            again — if it keeps happening, contact support.
                        </p>
                    }
                    onRetry={() => window.location.reload()}
                />
            }
            onError={(error) => {
                Sentry.captureException(error);
            }}
        >
            {children}
        </CommonClientProviders>
    );
}
